module.exports = __webpack_public_path__ + "static/media/success.6b8f8369.gif";